import { render, staticRenderFns } from "./Browsing.vue?vue&type=template&id=67c495e2&scoped=true"
import script from "./Browsing.vue?vue&type=script&lang=js"
export * from "./Browsing.vue?vue&type=script&lang=js"
import style0 from "./Browsing.vue?vue&type=style&index=0&id=67c495e2&prod&scoped=true&lang=css"
import style1 from "./Browsing.vue?vue&type=style&index=1&id=67c495e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c495e2",
  null
  
)

export default component.exports